import { render, staticRenderFns } from "./ConsumptionHistogramChartWidgetComponent.vue?vue&type=template&id=4ec1ceec&"
import script from "./ConsumptionHistogramChartWidgetComponent.vue?vue&type=script&lang=js&"
export * from "./ConsumptionHistogramChartWidgetComponent.vue?vue&type=script&lang=js&"
import style0 from "./ConsumptionHistogramChartWidgetComponent.vue?vue&type=style&index=0&id=4ec1ceec&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports